import { cn } from "@/libs/utils";
import { IconBaseType } from "@/v2-components/core/icon/type";
import React from "react";

export default function TagIcon({ className }: IconBaseType) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
    >
      <path
        d="M20.469 11.622L12.369 3.522C12.045 3.198 11.595 3 11.1 3H4.8C3.81 3 3 3.81 3 4.8V11.1C3 11.595 3.198 12.045 3.531 12.378L11.631 20.478C11.955 20.802 12.405 21 12.9 21C13.395 21 13.845 20.802 14.169 20.469L20.469 14.169C20.802 13.845 21 13.395 21 12.9C21 12.405 20.793 11.946 20.469 11.622ZM6.15 7.5C5.403 7.5 4.8 6.897 4.8 6.15C4.8 5.403 5.403 4.8 6.15 4.8C6.897 4.8 7.5 5.403 7.5 6.15C7.5 6.897 6.897 7.5 6.15 7.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
